import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import ReactDataTable from "react-data-table-component";
import {
  IconHomePlus,
  IconCloudDownload,
  IconTrash,
  IconUsers,
  IconTruckDelivery,
  IconEdit
} from "@tabler/icons-react";
import { UserServiceContext } from "../services/user/userService";
import ContactSelect from "./ContactSelect";
import CustomCombobox from "../components/CustomCombobox";
import NewAddressModal from "./app/modals/NewAddressModal";
import Loader from "../components/Loader";
import CustomAlert from "../components/CustomAlert";
import { paginationComponentOptions } from "../utils/constants";

const NewAddresses = () => {
  const { getUserFavoriteClients, deleteUserFavoriteClient, loading } =
    useContext(UserServiceContext);
  const [addresses, setAddresses] = useState([]);
  const [showAddressModal, setShowAddressModal] = useState(false);

  //if current object is set then edit mode otherwise create mode
  const [currentObject, setCurrentObject] = useState(undefined);

  const [alertConfig, setAlertConfig] = useState({
    show: false,
    title: "",
    text: "",
    icon: "",
    onConfirm: null,
    onCancel: null,
  });

  const fetchAddresses = async () => {
    const response = await getUserFavoriteClients();
    if (response && response.data) {
      setAddresses(response.data.clientAddress);
    }
  };

  useEffect(() => {
    fetchAddresses();
  }, []);

  useEffect(() => {
    if (addresses.length > 0) {
      //console.log(addresses);
    }
  }, [addresses]);

  const handleModalShow = (changed) => {
    setShowAddressModal(!showAddressModal);
    setCurrentObject(undefined);//clear current object anyways
    if (!changed) return;//if nothing is changed do not fetch addresses
    fetchAddresses();
  };


  const handleEditClick = (row, edit) => {
    setCurrentObject(row);
    setShowAddressModal(true);
    // setIsEdit(edit);
    // setShowAddressModal(true);
  };

  const handleContactComboValueChanged = (selecteditem, text, row) => {
    //console.log([selecteditem, text,row]);
    if (!selecteditem) return;
    const selectedAddress = selecteditem;
    row.selectedContactId = selectedAddress.id;
  }

  const handleDeliveryOrderCreate = (row) => {

    if (!row.selectedContactId) {
      setAlertConfig({
        show: true,
        title: "შეცდომა",
        text: "აირჩიეთ კონტაქტი",
        icon: "warning",
      });
    } else {
      window.open(
        `/u-delivery-request?contactId=${row.selectedContactId}`,
        "_blank"
      );
    }
  };


  const handleSelectChange = (id, target) => {
    console.log([id, target]);
    const selectedAddress = addresses.find((address) => address.id === id);
    const selectedContact = selectedAddress.contacts.find(
      (contact) => contact.id === parseInt(target)
    );

    if (selectedAddress) {
      const updatedAddresses = addresses.map((address) => {
        if (address.id === id) {
          return {
            ...address,
            selectedContactId: selectedContact.id,
          };
        }
        return address;
      });
      setAddresses(updatedAddresses);
    }
  };

  const handleDeleteAddress = (row) => {
    setAlertConfig({
      show: true,
      title: "დარწმუნებული ხართ?",
      text: "გსურთ ამ მისამართის წაშლა?",
      icon: "warning",
      showConfirmButton: true,
      onConfirm: async () => {
        await deleteUserFavoriteClient(row.id);
        setAlertConfig({ ...alertConfig, show: false });
        //fetchAddresses();
        fetchAddresses();
      },
      onCancel: () => {
        setAlertConfig({ ...alertConfig, show: false });
      },
    });
  };

  const handleDeliveryOrder = (addressId) => {
    //console.log(addressId);
    const address = addresses.find((address) => address.id === addressId);
    //console.log(address);
    if (!address.selectedContactId) {
      setAlertConfig({
        show: true,
        title: "შეცდომა",
        text: "აირჩიეთ კონტაქტი",
        icon: "warning",
      });
    } else {
      window.open(
        `/u-delivery-request?contactId=${address.selectedContactId}`,
        "_blank"
      );
    }
  };

  const columns = [
    {
      name: "მიმღების დასახელება",
      selector: (row) => row.name
    },
    {
      name: "პირადი/საიდენტიფიკაციო",
      selector: (row) => row.personalId,
    },
    {
      name: "ტიპი",
      selector: (row) => {
        return row.userTypeId == 1 ? "ფიზიკური" : "იურიდიული";
      },
      
      width: "120px",
    },
    {
      name: "კონტაქტი",
      cell: (row) => (
        !row.isDefault && (
          <div style={{ minWidth: "150px" }}>
            <CustomCombobox
              options={row.contacts}
              label="name"
              valueField="id"
              comboBoxOnly={true}
              // onValueChanged={handleContactComboValueChanged}
              onValueChanged={(item, text) => {
                handleContactComboValueChanged(item, text, row);
              }}
              selectedValue={row.selectedContactId}
            />
          </div>
        )),
    },
    {
      cell: (row) => (
        !row.isDefault && (
          <button
            className="btn btn-outline-secondary"
            onClick={() => handleDeliveryOrderCreate(row)}
            title="გამოძახება"
          >
            <IconTruckDelivery className="w-[18px] h-[18px]" />
          </button>
        )),
      width: "70px",
      style: { title: "გამოძახება" },
    },
    {
      cell: (row) => (
        <Link to={`${row.id}`} className="btn btn-outline-primary" title="კონტაქტების მართვა">
          <IconUsers className="w-[18px] h-[18px]" />
        </Link>
      ),
      width: "70px",
      style: { cursor: "pointer" },
    },
    {
      cell: (row) => (
        (<button
          className="btn btn-outline-danger"
          onClick={() => handleEditClick(row, true)}
          title="შესწორება"
        >
          <IconEdit className="w-[18px] h-[18px]" />
        </button>)
      ),
      width: "50px",
      style: { cursor: "pointer" },
    },
    {
      cell: (row) => (!row.isDefault && (
        <button
          className="btn btn-outline-danger"
          onClick={() => handleDeleteAddress(row)}
          title="წაშლა"
        >
          <IconTrash className="w-[18px] h-[18px]" />
        </button>)
      ),
      width: "60px",
      style: { cursor: "pointer" },
    },
  ];

  const conditionalRowStyles = [
    {
      when: (row) => row.isDefault == true,
      classNames: ['text-danger'],
      style: {
        // backgroundColor: "#f3fff4!important",
        color: "#2e7d32!important",
        fontWeight:"bold!important"
      }
    }
  ];

  return (
    <>
      {loading && <Loader />}
      <CustomAlert {...alertConfig} />
      {showAddressModal && (
        <NewAddressModal
          originalData={currentObject}
          isEdit={currentObject !== undefined}
          setCreateEventModal={handleModalShow} />
      )}
      <div className="flex items-center justify-between gap-4 flex-wrap mx-20 my-20">
        <h5 className="text-[20px]/[26px]"></h5>
        <div className="flex items-stretch gap-1 flex-wrap">
          <button
            className="btn btn-outline-secondary"
            onClick={() => setShowAddressModal(true)}
          >
            <IconHomePlus className="w-[18px] h-[18px]" />
            <span className="sm:block hidden">დამატება</span>
          </button>
          {/* <button className="btn btn-outline-secondary">
            <IconCloudDownload className="w-[18px] h-[18px]" />
            <span className="sm:block hidden">ექსპორტი</span>
          </button> */}
        </div>
      </div>
      <div className="react-data-table mx-20">
        <ReactDataTable
          pagination
          striped
          paginationComponentOptions={paginationComponentOptions}
          columns={columns}
          data={addresses}
          conditionalRowStyles={conditionalRowStyles}
          noDataComponent={
            <div
              style={{ textAlign: "center", padding: "20px", color: "gray" }}
            >
              მისამართები დამატებული არ გაქვთ
            </div>
          }
          style={{ overflow: "visible" }}
        />
      </div>
    </>
  );
};

export default NewAddresses;
